import { VStack } from "@gluestack-ui/themed";
import { Button } from "@repo/core/components/core/Button";
import { PROPOSAL_ACTIONS } from "@repo/core/constants/proposals";
import { getAnalysisQueueProposalOptions } from "@repo/core/screens/Proposals/rules/analysisQueueRules";

import { ProposalOptionsProps } from "./types";

const primaryActions = [
  PROPOSAL_ACTIONS.EFFECTIVE_PROPOSAL,
  PROPOSAL_ACTIONS.FIDELITY_EFFECTIVE
];

const getPrimaryActionLabel = (
  proposalStatus?: string,
  proposalType?: string,
  permissions?: string[]
): string => {
  const options = getAnalysisQueueProposalOptions(
    proposalStatus,
    proposalType,
    undefined,
    permissions
  );
  const primaryOption = options.find((option) =>
    primaryActions.includes(option.action)
  );
  return primaryOption?.label || "";
};

export const ProposalsOptions = ({
  onPressEffectiveProposal,
  proposalStatus,
  proposalType,
  permissions,
  isLoading = false
}: ProposalOptionsProps) => {
  const buttonText = getPrimaryActionLabel(
    proposalStatus,
    proposalType,
    permissions
  );

  if (!buttonText) {
    return null;
  }

  return (
    <VStack>
      <Button
        text={buttonText}
        size="md"
        action="primary"
        mb="$4"
        onPress={onPressEffectiveProposal}
        isLoading={isLoading}
        isDisabled={isLoading}
      />
    </VStack>
  );
};
